import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';
import { cleanValidationFields } from '../../../utilities/dataAdapters';

// To Do: use baseURL and remove full url from query

export const kanbanApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getKanban: builder.query({
            query: ({ maxResults = 200, city, statuses = [], project = false }) => {
                let params = `max-result=${maxResults}`;
                if (city) {
                    params += `&state=CA&city=${city}`;
                }
                if (statuses.length) {
                    params += `&statuses=[${statuses.join(',')}]`;
                }
                if (project) {
                    params += '&project=true';
                }
                return `${getBaseURL()}/kanban?${params}`;
            },
            transformResponse: (response) => {
                const transformedRecords = response.records.map((prop) => {
                    return {
                        ...prop,
                        validation_fields: cleanValidationFields(prop?.validation_fields),
                    };
                });
                return { ...response, records: transformedRecords };
            },
            providesTags: ['Kanban'],
        }),
    }),
});

export const { useLazyGetKanbanQuery } = kanbanApiSlice;
